import React from "react"; //{ useMemo }
import { Link, useNavigate, useParams, } from "react-router-dom"; //useLocation 
import styled from "styled-components";
import { IPost } from "../types/IPost";
import { MOCK_POSTS } from "./Blog.constants";

const BlogPost =()  =>{
  const { slug } = useParams();
  const navigate = useNavigate();
  const posts = MOCK_POSTS; // replace with real data

  const index = posts.findIndex(p => p.slug === slug);
  const post: IPost = posts[index] || posts[0];
  const prev = index > 0 ? posts[index-1] : null;
  const next = index < posts.length-1 ? posts[index+1] : null;
  const yyyy = (post.dateISO || "").slice(0,4);

  if (!post) return <Wrap>Post not found.</Wrap>;

  return (
    <Wrap>
      <h1>{post.title}</h1>
      <Meta>
        <span>{post.dateText}</span>
        {yyyy && <span> • <Link to={`/blog?year=${yyyy}`}>{yyyy}</Link></span>}
        {post.author?.name && <span> • by <a href={post.author.href || "#"}>{post.author.name}</a></span>}
        {post.categories?.length ? (
          <span> • in {post.categories.map((c,i)=>(
            <React.Fragment key={c.name}>
              <Link to={`/blog?category=${encodeURIComponent(c.name)}`}>{c.name}</Link>
              {i < post.categories.length-1 ? ", " : null}
            </React.Fragment>
          ))}</span>
        ) : null}
      </Meta>

      <Content>
        {post.content?.map((p,i)=><p key={i}>{p}</p>)}
      </Content>

      {post.tags?.length ? (
        <Tags>
          <span>Tags: </span>
          {post.tags.map((t,i)=>{
            const name = t.name;
            return (
              <React.Fragment key={name}>
                <Link to={`/blog?tag=${encodeURIComponent(name)}`}>{name}</Link>
                {i < post.tags.length-1 ? ", " : null}
              </React.Fragment>
            );
          })}
        </Tags>
      ) : null}

      <Nav>
        {prev ? <Link to={`/blog/${prev.slug}`}>‹ {prev.title}</Link> : <span />}
        <Link to="/blog">All posts</Link>
        {next ? <Link to={`/blog/${next.slug}`}>{next.title} ›</Link> : <span />}
      </Nav>
    </Wrap>
  );
}

const Wrap = styled.div`max-width:820px;margin:0 auto;padding:36px 20px 64px;`;
const Meta = styled.div`color:#777;font-size:14px;display:flex;flex-wrap:wrap;gap:8px 12px;margin:10px 0;`;
const Content = styled.div`margin-top:12px;line-height:1.75;color:#333;`;
const Tags = styled.div`margin-top:20px;color:#666;`;
const Nav = styled.div`margin-top:28px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;`;

export default BlogPost;